module.exports = __webpack_public_path__ + "static/bg-video-8f4af7937b64aa487d47cc93ba1f5a9d.mp4";